import React from 'react';
import { Strip } from '../../Models/Article';
import { HeroStripParams, NewsHeaderStripParams } from '../../Models/Dashboard/DashNewsItem';
import { HeroStrip } from './HeroStrip';
import { NewsHeaderStrip } from './NewsHeaderStrip';

interface NewsHeaderOrHeroStripProps {
    strip: Strip;
}

export function NewsHeaderOrHeroStrip({ strip }: NewsHeaderOrHeroStripProps) {
    return (strip.params as NewsHeaderStripParams | HeroStripParams).isHeroBanner
        ? <HeroStrip strip={strip} />
        : <NewsHeaderStrip strip={strip} />;
}
